import { render, staticRenderFns } from "./card-badges.vue?vue&type=template&id=5594963b&scoped=true"
import script from "./card-badges.vue?vue&type=script&lang=js"
export * from "./card-badges.vue?vue&type=script&lang=js"
import style0 from "./card-badges.vue?vue&type=style&index=0&id=5594963b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5594963b",
  null
  
)

export default component.exports